import React from "react";

// material components
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Paper from "@material-ui/core/Paper";

// custom components
import ReturnsTable from "./ReturnsTable";
import ReturnsForm from "./ReturnsForm";
import withShipment from "../../withShipment";
import CustomToolbar from "../global/CustomToolbar";

// constants
import {
    CREATE_RETURN_TITLE,
    RETURN_TOOLBAR_TITLE,
    BACK_TO_MENU,
    DEFAULT_ROWS_PER_PAGE,
    COMPLETED_STATUS
} from "./constants";
import {
    isMPSReturnSelector,
    refundAmountSelector,
    returnActionsSelector,
    returnConditionsSelector, returnSettingsSelector, refundDetailsSelector,
    returnsSelector,
} from '../../redux/selectors/returns';
import {
    createReturn,
    listReturnActions,
    listReturnConditions,
    listReturns,
    previewReturnFile,
    updateReturnItem,
    listUncompletedReturns,
    fetchRmaInfo,
    fetchReturnInfo,
    getReturnSettings,
    updateReturnSettings,
    calculateReturnRefundAmount,
    clearReturnRefundAmount,
} from "../../redux/actions/returns";
import {
    listReturnReasons,
} from "../../redux/actions/returns";
import {
    getUsers,
} from "../../redux/actions/auth";
import {
    returnReasonsSelector,
    rmaFetchSelector,
    duplicateRmasSelector
} from "../../redux/selectors/returns";
import {listAvailableLocations, listProducts} from "../../redux/actions/settings";
import { availableLocationsSelector, productsSelector } from "../../redux/selectors/settings";
import {selectedLocationIdSelector, userInfoSelector, usersSelector} from "../../redux/selectors/auth";
import PropTypes from "prop-types";
import {
    saveTableSetting,
    getTableSetting
} from "../../redux/actions/account";
import {
    tableSettingSelector
} from "../../redux/selectors/account";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {EditOff} from "@mui/icons-material";
import SettingsIcon from '@material-ui/icons/Settings';
import ReturnSettings from './ReturnSettings';
// redux

// styling

class Returns extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            creatingReturn: false,
            returnOpened: null,
            searchText: '',
            editingCompletedReturn: false,
            isOpenSettings: false
        }
    }

    componentDidMount() {
        this.props.listProducts()
        this.props.getUsers()
        this.props.listReturnActions()
        this.props.listReturnConditions()
        this.props.listReturnReasons()
        this.props.listAvailableLocations()
        this.props.getTableSetting()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if a return is opened and a return updates (preview loaded)
        if (prevProps.returns !== this.props.returns && this.state.returnOpened !== null) {
            // find the opened return
            let curReturn = this.state.returnOpened
            let returnId = curReturn.returnId
            let updatedReturn = this.props.returns.find(returnItem => {
                return returnItem.returnId === returnId
            })

            curReturn.files = updatedReturn.files
            this.setState({
                returnOpened: curReturn
            })
        }
        if (prevProps.tableSetting !== this.props.tableSetting) {
            if (this.props.tableSetting?.returnsFilterSetting?.showCompletedReturns) {
                this.props.listReturns()
            } else {
                this.props.listUncompletedReturns()
            }
        }
    }

    setPage = (page) => {
        this.setState({
            page: page
        })
    }

    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    creatingReturn = () => {
        this.setState({
            creatingReturn: true
        })
    }

    cancelReturn = () => {
        this.setState({
            creatingReturn: false,
            returnOpened: null,
            editingCompletedReturn: false,
        })
    }

    handleSubmitReturn = (data, creatingNewReturn) => {
        if (creatingNewReturn) {
            data["userInfo"] = {
                createdByName: `${this.props.currentUser.firstname} ${this.props.currentUser.lastname}`,
                createdById: this.props.currentUser.userId
            }
            delete data["files"] // we only care about the new files
            this.props.createReturn(data, () => window.location.reload())
        }
        else {
            delete data["files"] // we only care about the new files and deleted files
            data["editingCompletedReturn"] = this.state.editingCompletedReturn
            let refundDetails = data["refundDetails"];

            if (refundDetails != null && typeof refundDetails === "object") {
                const normalizedDetails = Object.fromEntries(
                    Object.entries(refundDetails).map(([key, value]) => {
                        if (value === null || value === undefined) {
                            return [key, value];
                        }

                        if (isNaN(Number(value))) {
                            return [key, value];
                        }

                        const formatted = Number(value).toFixed(2);

                        return [key, formatted];
                    })
                );

                data["refundDetails"] = normalizedDetails;
            }
            this.props.updateReturnItem(data, () => window.location.reload())
        }
    }

    openSettings = (bool) =>{
        this.setState({isOpenSettings: bool})

    }

    openReturn = (returnItem) => {
        this.setState({
            returnOpened: returnItem
        })
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    setEditingCompletedReturns = () => {
        this.setState({
            editingCompletedReturn: !this.state.editingCompletedReturn
        })
    }

    render() {
        let headerButtons = []
        if (!this.state.returnOpened && !this.state.creatingReturn) {
            headerButtons = [
                { icon: <AddCircleIcon />, handler: this.creatingReturn, title: "Create Return" },
                { icon: <SettingsIcon />, handler: ()=> this.openSettings(true), title: "Return Settings" },
            ]
        }
        else {
            headerButtons = [
                { icon: <KeyboardBackspaceIcon />, handler: this.cancelReturn, title: "Back" },
            ]
        }
        if (this.state.returnOpened?.status == COMPLETED_STATUS) {
            headerButtons = [
                { icon: <KeyboardBackspaceIcon />, handler: this.cancelReturn, title: "Back" },
                this.state.editingCompletedReturn ?
                     { icon: <EditOff />, handler: this.setEditingCompletedReturns, title: "Stop Editing" }
                    :{ icon: <EditIcon />, handler: this.setEditingCompletedReturns, title: "Edit" },
            ]
        }
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ErrorFeedbackBar />
                <Paper className='paper'>
                    {!this.state.isOpenSettings &&
                        <CustomToolbar
                            title={RETURN_TOOLBAR_TITLE}
                            createTitle={CREATE_RETURN_TITLE}
                            backTitle={BACK_TO_MENU}
                            onClick={this.creatingReturn}
                            handleClose={this.cancelReturn}
                            headerButtons={headerButtons}
                            creatingOrder={this.state.creatingReturn || (!!this.state.returnOpened)}
                        />
                    }
                    {this.state.isOpenSettings &&
                        <ReturnSettings
                          openSettings={this.openSettings}
                          getReturnSettings={this.props.getReturnSettings}
                          returnSettings={this.props.returnSettings}
                          updateReturnSettings={this.props.updateReturnSettings}
                        />
                    }
                    {!this.state.isOpenSettings && (
                        !this.state.returnOpened ?
                            this.state.creatingReturn ?
                            <ReturnsForm
                                cancel={this.cancelReturn}
                                creatingForm={true}
                                submit={this.handleSubmitReturn}
                                returnItem={null}
                                returnActions={this.props.returnActions}
                                returnConditions={this.props.returnConditions}
                                currentUser={this.props.currentUser}
                                returnReasons={this.props.returnReasons}
                                users={this.props.users}
                                locations={this.props.availableLocations}
                                products={this.props.products}
                                fetchRmaInfo={this.props.fetchRmaInfo} // send to backend
                                rmaFetch={this.props.rmaFetch} // get from backend & selector
                                editingCompletedReturn={this.state.editingCompletedReturn}
                            />
                            :
                            <ReturnsTable
                                rows={this.props.returns}
                                page={this.state.page}
                                setPage={this.setPage}
                                rowsPerPage={this.state.rowsPerPage}
                                setRowsPerPage={this.setRowsPerPage}
                                currentUser={this.props.currentUser}
                                handleDoubleClick={this.openReturn}
                                tableSetting={this.props.tableSetting}
                                saveTableSetting={this.props.saveTableSetting}
                                user={this.props.currentUser}
                                searchText={this.state.searchText}
                                handleSearchChange={this.handleSearchTextChange}
                                selectedLocation={this.props.selectedLocation}
                            />

                        :
                        <ReturnsForm
                            cancel={this.cancelReturn}
                            creatingForm={false}
                            submit={this.handleSubmitReturn}
                            returnActions={this.props.returnActions}
                            returnConditions={this.props.returnConditions}
                            returnItem={this.state.returnOpened}
                            returnReasons={this.props.returnReasons}
                            currentUser={this.props.currentUser}
                            users={this.props.users}
                            fetchFilePreview={this.props.previewReturnFile}
                            locations={this.props.availableLocations}
                            products={this.props.products}
                            fetchRmaInfo={this.props.fetchRmaInfo} // send to backend
                            rmaFetch={this.props.rmaFetch} // get from backend & selector
                            fetchReturnInfo={this.props.fetchReturnInfo}
                            duplicateRmas={this.props.duplicateRmas}
                            isMPSReturn={this.props.isMPSReturn}
                            editingCompletedReturn={this.state.editingCompletedReturn}
                            calculateReturnRefundAmount={this.props.calculateReturnRefundAmount}
                            refundAmount={this.props.refundAmount}
                            refundDetails={this.props.refundDetails}
                            clearReturnRefundAmount={this.props.clearReturnRefundAmount}
                        />
                    )
                }

                </Paper>
            </MuiPickersUtilsProvider>
        );
    }
}

const mapStateToProps = (state) => ({
    returns: returnsSelector(state),
    returnActions: returnActionsSelector(state),
    returnConditions: returnConditionsSelector(state),
    returnReasons: returnReasonsSelector(state),
    currentUser: userInfoSelector(state),
    users: usersSelector(state),
    availableLocations: availableLocationsSelector(state),
    products: productsSelector(state),
    tableSetting: tableSettingSelector(state),
    rmaFetch: rmaFetchSelector(state),
    duplicateRmas: duplicateRmasSelector(state),
    selectedLocation: selectedLocationIdSelector(state),
    refundAmount: refundAmountSelector(state),
    isMPSReturn: isMPSReturnSelector(state),
    returnSettings: returnSettingsSelector(state),
    refundDetails: refundDetailsSelector(state)
});

const actionCreators = {
    listReturns,
    listProducts,
    getUsers,
    createReturn,
    listReturnActions,
    listReturnConditions,
    updateReturnItem,
    previewReturnFile,
    listReturnReasons,
    listAvailableLocations,
    saveTableSetting,
    getTableSetting,
    listUncompletedReturns,
    fetchRmaInfo,
    fetchReturnInfo,
    getReturnSettings,
    updateReturnSettings,
    calculateReturnRefundAmount,
    clearReturnRefundAmount,
}

Returns.propTypes = {
    returns: PropTypes.array,
    returnActions: PropTypes.array,
    returnConditions: PropTypes.array,
    currentUser: PropTypes.object,
    users: PropTypes.array,
    availableLocations: PropTypes.array,
    duplicateRmas: PropTypes.array,
}

Returns.defaultProps = {
    returns: [],
    returnActions: [],
    returnConditions: [],
    currentUser: {},
    users: [],
    availableLocations: [],
    duplicateRmas: [],
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, Returns);